import {ColumnsType} from "antd/lib/table";
import {BeerDto, Direction} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";
import {Button} from "antd";
import {ArrowDownOutlined, ArrowUpOutlined} from "@ant-design/icons";
import styles from "./beerListContainer.module.scss";

export default function BeersList(props: BeersProps) {
    const minPosition = props.data ? Math.min(...props.data.map(e => e.position!)) : 0;
    const maxPosition = props.data ? Math.max(...props.data!.map(e => e.position!)) : 0;

    const columns: ColumnsType<BeerDto> = [
        {
            key: nameof<BeerDto>("position"),
            dataIndex: nameof<BeerDto>("position"),
            title: "Pozycja",
            render: (position, record) => <>
                <Button
                    style={position === minPosition ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowUpOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Up)}
                />
                <Button
                    style={position === maxPosition ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowDownOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Down)}
                /></>
        },
        {
            key: nameof<BeerDto>("name"),
            dataIndex: nameof<BeerDto>("name"),
            title: "Nazwa"
        },
        {
            key: nameof<BeerDto>("description"),
            dataIndex: nameof<BeerDto>("description"),
            title: "Opis"
        },
    ];

    return <>
        <Button type="primary" onClick={props.onAddClicked} className={styles.newBeerButton}>
            + Dodaj nowe piwo
        </Button>
        <CrudTable
            data={props.data}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            columns={columns}
            actionsFixed={false}
            editButtonTitle="Edytuj"
            deleteButtonTitle="Usuń"
            deleteConfirmMessage="Czy na pewno chcesz usunąć to piwo?"
            cancelButtonTitle="Anuluj"
            addButtonTitle={"+ Dodaj nowe piwo"}
            pagination={{showSizeChanger: true}}
        />
    </>
}

interface BeersProps extends CrudTableWrapperProps<BeerDto> {
    onPositionChangeClicked: (id: number, direction: Direction) => void
}
